<script src="../../environments/environment.prod.ts"></script>
<div class="w-100">
  <div class="container d-sm-none">
    <div class="row d-flex justify-content-center landing__ticker">
      
    </div>
  </div>
</div>


<div class="w-100 border-bottom px-10px">
  <div class="container-lg landing__header">
    <div class="row">
      <div>
        <h3>Combat Collective</h3>
      </div>
      </div>
    </div>
  </div>


<div class="container-lg border-left border-right landing__hero">
  <div class="row">
    <div class="col text-center">
      <h1 class="font-weight-bold text-black slide-up-1">
        Combat Collective
      </h1>
      <div class="slide-up-2">
        <a
          class="btn btn-primary landing__sign-up"
          (click)="globalVars.launchSignupFlow()"
        >
          <div style="font-weight: bold; font-size: 20px">Sign Up</div>
        </a>
        <a
          class="landing__log-in d-none d-sm-block"
          (click)="globalVars.launchLoginFlow()"
          style="font-size: 15px"
        >
          Log in
        </a>
        <a
          class="landing__log-in d-block d-sm-none mt-3"
          (click)="globalVars.launchLoginFlow()"
          style="font-size: 15px"
        >
          Log in
        </a>
      </div>
    </div>
  </div>


   

<div class="w-100 landing__echo">
  <div class="container">
    <div class="row d-flex justify-content-center">
      <div class="col mb-0 text-center">
        <p class="text-grey9 fs-20px"> A Dentralized Social Network built to empower Martial Artists.</p>
        <br />
        <p class="text-grey9 fs-20px"> Leverage content on the DeSo-Blockchain to monetize and add longevity to your competitive career.</p>
        <br />
      </div>
    </div>
  </div>
</div>